module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-static"
  }, [(!_vm._readonly) ? _c('p', [_c('el-button', {
    staticClass: "btn",
    staticStyle: {
      "float": "left",
      "margin-right": "10px"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18n.fr(_vm.spec.multi ? 'action.upload' : 'action.upload_replace')) + "\n    ")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "file",
      "multiple": _vm.spec.multi,
      "accept": _vm.spec.accept
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.value_), function(id, i) {
    return _c('p', [(!_vm._readonly) ? _c('el-button', {
      staticClass: "btn btn-icon btn-danger",
      on: {
        "click": function($event) {
          _vm.del(i)
        }
      }
    }, [_c('i', {
      staticClass: "ti-close"
    })]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.mediaUrl(id),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.displayName(id)))])], 1)
  }), _vm._v(" "), (_vm._readonly && _vm.value_.length == 0) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.fr('html.empty'))
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46021666!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-file.vue
// module id = 518
// module chunks = 55